import React, { Component } from 'react'
import { connect } from 'react-redux'

import { loadAttendances } from '../actions/Attendances'
import { loadMembers } from '../actions/Members'
import { loadCourses } from '../actions/Courses'

import DualRing from './DualRing'
import AjaxSpinner from './AjaxSpinner'
import Error from './Error'

import Calendar from './Attendances/Calendar'
import MemberItem from './Attendances/MemberItem'
import { memberTypes } from '../options.json'

const initialState = {
  search: '',
  search_course: '',
  selected: null,
  search_member_type: '',
  selectedName: null
}

class Attendances extends Component {
  constructor() {
    super()
    this.state = initialState
    this.showCalendar = this.showCalendar.bind(this)
    this.closeCalendar = this.closeCalendar.bind(this)
  }
  componentWillMount() {
    if (this.props.members.list === null) {
      this.props.loadMembers()
    }
    if (this.props.courses.list === null) {
      this.props.loadCourses()
    }
  }
  reloadmembers() {
    this.setState({ selected: null })
    this.props.loadMembers()
  }
  componentDidUpdate(prevProps, prevState) {
    // const m = this.props.members.list
    // if (this.state.selected === null && m !== null && m.length > 0) {
    //   this.setState({ selected: m[0].id })
    // }
    if (
      prevState.selected !== this.state.selected &&
      this.state.selected !== null
    ) {
      this.props.loadAttendances(this.state.selected)
    }
    if (prevProps.fiscalyear.current !== this.props.fiscalyear.current) {
      this.setState({ selected: null })
    }
    // if (prevState.search_course !== this.state.search_course) {
    //   this.setState({ selected: null })
    // }
    // if (prevProps.receipts.ajaxSpinner && (!this.props.receipts.ajaxSpinner && this.props.receipts.ajaxStatus === null)) {
    //   this.hideModal()
    // }
    // if (prevProps.receipts.ajaxSpinner && (!this.props.receipts.ajaxSpinner && this.props.receipts.ajaxStatus !== null)) {
    //   setTimeout(() => { this.props.clearAjaxCall('') }, 3000)
    // }
  }
  closeCalendar() {
    this.setState({ selected: null })
  }
  showCalendar(m) {
    this.setState({ selected: m.id, selectedName: m.name_surname })
  }
  filterList(list) {
    if (list === null) {
      return null
    }
    return list
      .filter((item) => {
        return this.state.search_member_type === ''
          ? true
          : item.active.toString() === this.state.search_member_type
      })
      .filter((item) => {
        return this.state.search_course === ''
          ? true
          : item.course_id.toString() === this.state.search_course
      })
      .filter(
        (el) =>
          el.name_surname
            .toLowerCase()
            .indexOf(this.state.search.toLowerCase()) >= 0 ||
          el.email.toLowerCase().indexOf(this.state.search.toLowerCase()) >=
            0 ||
          el.fiscal_code
            .toLowerCase()
            .indexOf(this.state.search.toLowerCase()) >= 0
      )
  }
  render() {
    const { list, error, loading } = this.props.members
    const { dates, ajaxSpinner } = this.props.attendances
    const filteredList = this.filterList(list)
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Presenze</div>
          <div className='ph-descr'>
            <ul className='ul-filter'>
              <li>
                <input
                  type='text'
                  placeholder='Cerca anagrafiche'
                  onChange={(event) =>
                    this.setState({
                      search: event.target.value,
                      selected: null
                    })
                  }
                  value={this.state.search}
                />
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({
                      search_course: event.target.value,
                      selected: null
                    })
                  }
                  value={this.state.search_course}
                >
                  <option value=''>Tutti i corsi</option>
                  {this.props.courses.list !== null &&
                    this.props.courses.list.map((o, index) => {
                      return (
                        <option key={index} value={o.id}>
                          {o.name}
                        </option>
                      )
                    })}
                </select>
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_member_type: event.target.value })
                  }
                  value={this.state.search_member_type}
                >
                  {memberTypes.map((o, index) => {
                    return (
                      <option key={index} value={o.value}>
                        {o.label}
                      </option>
                    )
                  })}
                </select>
              </li>
            </ul>
          </div>
          <ul className='ph-btn'>
            <li>
              <button
                onClick={() => this.reloadmembers()}
                className='lnk-tools'
              >
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          <div className='ph-count'>
            {filteredList !== null &&
              filteredList.length +
                (filteredList.length === 1 ? ' risultato' : ' risultati')}
            {filteredList === null && <i className='fas fa-sync fa-spin'></i>}
          </div>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        <div className='att-container'>
          {this.state.selected !== null && !loading && (
            <div className='att-calendar'>
              {dates !== null && (
                <Calendar
                  dates={dates}
                  selected={this.state.selected}
                  selectedName={this.state.selectedName}
                  closeCalendar={this.closeCalendar}
                />
              )}
              {dates === null && <DualRing />}
            </div>
          )}
          <div className='att-list'>
            {list !== null &&
              filteredList.map((m, index) => {
                return (
                  <MemberItem
                    key={index}
                    selected={this.state.selected}
                    showCalendar={this.showCalendar}
                    member={m}
                  />
                )
              })}
          </div>
        </div>
        {ajaxSpinner && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadMembers,
  loadCourses,
  loadAttendances
})(Attendances)



// WEBPACK FOOTER //
// ./src/components/Attendances.js